import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import TableSkeleton from "../../../components/skeletons/TableSkeleton";

const RecipientsSkeleton = () => {
	return (
		<Box>
			<Box sx={{ display: "flex", gap: "4px" }}>
				<Skeleton variant="rectangular" width={108} height={48} />
				<Skeleton variant="rectangular" width={100} height={48} />
				<Skeleton variant="rectangular" width={100} height={48} />
				<Skeleton variant="rectangular" width={100} height={48} />
				<Skeleton variant="rectangular" width={100} height={48} />
				<Skeleton variant="rectangular" width={120} height={48} />
			</Box>
			<Box
				sx={{
					mt: "38px",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Skeleton variant="rectangular" width={140} height={40} />
				<Skeleton variant="rectangular" width={300} height={12} />
			</Box>
			<Box sx={{ mt: "62px" }}>
				<TableSkeleton />
			</Box>
		</Box>
	);
};

export default RecipientsSkeleton;
